<div class="fdm-floatbar" *ngIf="transformType">
  <div class="fdm-sidebar-header fdm-sidebar-header-primary fdm-buttons fdm-shadow clearfix">

    <li class="fdm-linked fdm-options-button pointer" (click)="cancel()">
      <fa-icon icon="times"></fa-icon>
    </li>
    <h2>{{ transformType.name }}</h2>
  </div>
    <div class="p3" style="padding:20px;">
      {{ transformType.desc }}
    </div>
    <mat-vertical-stepper  #stepper>
      <mat-step >
          <ng-template matStepLabel>{{ 'GENERIC.SELECT_INPUT' | translate }}</ng-template>
          <div *ngFor="let file of files">
            {{ file.name }} 
          </div>
          <div>
            <button mat-raised-button (click)="pickFiles()">{{ 'GENERIC.SELECT_FILES' | translate }}</button>
          </div>
    
      </mat-step>
      <mat-step *ngIf="qMap">
          <ng-template matStepLabel> {{ 'MAP.PHOTOGRAM.ADDITIONAL_INFO' | translate }}</ng-template>
          <div qmap-question *ngFor="let curQ of qMap" [qMap]="curQ" [model]="arguments"></div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>{{ 'MAP.PHOTOGRAM.START' | translate }}</ng-template>
        <div>
          <button mat-raised-button (click)="start()" [disabled]="files.length != 1">
            {{ 'MAP.PHOTOGRAM.BEGIN_PROCESSING' | translate }}</button>
        </div>
      </mat-step>
    </mat-vertical-stepper>

</div>


<div class="fdm-floatbar" *ngIf="jobType && job">
  <div class="fdm-sidebar-header fdm-sidebar-header-primary fdm-buttons fdm-shadow clearfix">

  
    <li class="fdm-linked fdm-options-button pointer" (click)="cancel()">
      <fa-icon icon="times"></fa-icon>
    </li>
    <li class="fdm-linked fdm-options-button pointer" *ngIf="job.id" (click)="nuke()">
      <fa-icon icon="trash"></fa-icon>
    </li>
    <h2>{{ jobType.name }}</h2>
  </div>
    <div class="p3" style="padding:20px;">
      {{ jobType.desc }}
    </div>
    <mat-form-field class="p-2 w-100">
      <input type="text" name="name" [(ngModel)]="job.name" placeholder=" {{ 'MAP.PHOTOGRAM.JOB_NAME' | translate }}" matInput (blur)="job.saveObservable().subscribe()"/>
    </mat-form-field>
    <mat-vertical-stepper  #stepper>
      <mat-step >
          <ng-template matStepLabel>{{ 'GENERIC.SELECT_INPUT' | translate }}</ng-template>
          <div *ngFor="let file of files">
            <fa-icon icon="times" class="float-right" (click)="rmFile(file)"></fa-icon>
            {{ file.name }}
          </div>
          <div>
            <button mat-raised-button (click)="pickFiles()">{{ 'GENERIC.SELECT_FILES' | translate }}</button>
          </div>
    
      </mat-step>
      <mat-step *ngIf="qMap">
          <ng-template matStepLabel>{{ 'MAP.PHOTOGRAM.ADDITIONAL_INFO' | translate }}</ng-template>
          <div qmap-question *ngFor="let curQ of qMap" [qMap]="curQ" [model]="arguments"></div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>{{ 'MAP.PHOTOGRAM.START' | translate }}</ng-template>
        <div>
          <button mat-raised-button (click)="start()" [disabled]="!this.job && files.length != 1">
            {{ 'MAP.PHOTOGRAM.BEGIN_PROCESSING' | translate }}
          </button>
        </div>
      </mat-step>
    </mat-vertical-stepper>
    <div *ngIf="batches.length" class="p-2">
      <h3 translate class="primary"> GENERIC.BATCHES</h3>
      <div *ngFor="let b of batches" [matTooltip]="b.desc">
        {{ b.name }} <i>{{ b.status}}</i>
      </div>
    </div>
</div>